export default "__VITE_ASSET__D25osQyf__"